import { useEffect, useState } from "react";
import { Grant, api } from "../api";
import { useAuth } from "../auth";

export function MyAccessPage() {
  const { token } = useAuth();
  const [grants, setGrants] = useState<Grant[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    api
      .myGrants(token)
      .then(setGrants)
      .catch((e) => setError(String(e?.message ?? e)));
  }, [token]);

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">My access</h2>
      <p className="text-sm text-slate-600">
        Schemas you can read through Claude / the MCP — the union of the grants from the roles you
        belong to. To request more access, ask an admin to add you to a role (Account management →
        Roles).
      </p>
      {error && (
        <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
          {error}
        </div>
      )}
      <div className="card overflow-hidden">
        {grants === null ? (
          <p className="p-4 text-sm text-slate-500">Loading…</p>
        ) : grants.length === 0 ? (
          <p className="p-4 text-sm text-slate-500">No grants assigned.</p>
        ) : (
          <table className="table-clean">
            <thead>
              <tr>
                <th>RDS id</th>
                <th>Schema</th>
              </tr>
            </thead>
            <tbody>
              {grants.map((g) => (
                <tr key={`${g.rds_id}:${g.schema_name}`} className="border-t border-slate-100">
                  <td className="font-mono">{g.rds_id}</td>
                  <td>{g.schema_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
